import axios from 'axios';
const instance = axios.create({
   // baseURL: 'https://api.maavybooks.com/api/'
   //baseURL: 'http://localhost/thestartupconnect/thestartup/'

   //Online
   //baseURL : 'https://api.thestartupconnect.com/api/'
  //  baseURL : 'https://thestartupconnect.com/api/'
   baseURL : 'https://businesssamadhan.in/api/'
   //Offline
  // baseURL : 'http://127.0.0.1:8000/api/'
});
export default instance;